import { defineStore } from "pinia";
// useStore could be anything like useUser, useCart
// the first argument is a unique id of the store across your application
export const useAlertsStore = defineStore("alerts", {
  state: () => {
    return {
      alerts: [] as {
        id: number;
        type: "success" | "error" | "info";
        message: string;
        time?: number;
      }[]
    };
  },

  actions: {
    addAlert(type: "success" | "error" | "info", message: string, timeSeconds = 7) {
      const alert = {
        id: Date.now(),
        type: type,
        message: message,
        time: timeSeconds
      };
      this.alerts.push(alert);
      if (timeSeconds) {
        setTimeout(() => {
          this.removeAlert(alert);
        }, timeSeconds * 1000);
      }
    },
    removeAlert(alert) {
      this.alerts = this.alerts.filter((a) => a.id !== alert.id);
    }
  }
});
